// @owners { team: patients }
const ReactNativeBiometrics = {
  createKeys: () => null,
  isSensorAvailable: () => false,
  createSignature: () => null,
  simplePrompt: (config: Record<string, unknown>) => config,
};

export { ReactNativeBiometrics };
